// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"styles_headerContainer__iHduG","headerContent":"styles_headerContent__as5rG"};